(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    

(() => {
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initBar(bar) {
    if (bar.dataset.announcementInit === 'true') return;
    bar.dataset.announcementInit = 'true';

    const slides = Array.from(bar.querySelectorAll('[data-announcement-slide]'));
    if (slides.length <= 1) return;

    const prevBtn = bar.querySelector('[data-announcement-prev]');
    const nextBtn = bar.querySelector('[data-announcement-next]');
    let index = 0;
    let timer = null;

    const goTo = (i) => {
      index = (i + slides.length) % slides.length;
      slides.forEach((slide, n) => {
        const active = n === index;
        slide.classList.toggle('is-active', active);
        if (active) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });
    };

    const autoplay = bar.dataset.autoplay === 'true';
    const interval = parseInt(bar.dataset.interval, 10) || 5000;

    const start = () => {
      if (!autoplay || REDUCED_MOTION || timer) return;
      timer = setInterval(() => goTo(index + 1), interval);
    };

    const stop = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    prevBtn?.addEventListener('click', () => { stop(); goTo(index - 1); start(); });
    nextBtn?.addEventListener('click', () => { stop(); goTo(index + 1); start(); });

    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', start);

    start();
  }

  const initAll = () => document.querySelectorAll('[data-announcement-bar]').forEach(initBar);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: re-init when the section is reloaded
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-announcement-bar]').forEach(initBar);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
(function () {
  /* ---- Mobile link-column accordions ---- */
  function onHeadingClick(event) {
    var btn = event.currentTarget;
    // Only meaningful while the mobile accordion CSS is active.
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
  }

  function initAccordions(root) {
    var headings = (root || document).querySelectorAll('.site-footer__nav-heading');
    for (var i = 0; i < headings.length; i++) {
      var h = headings[i];
      if (h.dataset.footerAccordionBound) continue;
      h.dataset.footerAccordionBound = 'true';
      h.addEventListener('click', onHeadingClick);
    }
  }

  /* ---- Mailchimp newsletter (JSONP) — shared with the Newsletter section ---- */
  var jsonpSeq = 0;

  function initForm(form) {
    if (form.dataset.nlBound) return;
    form.dataset.nlBound = 'true';

    var body = form.querySelector('[data-nl-body]');
    var submit = form.querySelector('[data-nl-submit]');
    var successBox = form.querySelector('[data-nl-success]');
    var successMsg = form.querySelector('[data-nl-success-msg]');
    var errorBox = form.querySelector('[data-nl-error]');
    var errorMsg = form.querySelector('[data-nl-error-msg]');
    var emailInput = form.querySelector('input[name="EMAIL"]');
    var fallbackBtn = form.querySelector('[data-nl-fallback]');

    // Mailchimp's own hosted form is the only path that can satisfy the audience's
    // bot check, so hand the shopper over to it with the email carried across.
    // Two reasons this hangs off a real click rather than firing automatically
    // from the JSONP callback: form.submit() honours the form's target="_blank",
    // and a window opened from an async callback is outside the user-gesture
    // window, so the popup blocker eats it. form.submit() also does NOT fire a
    // submit event, which is what keeps it from re-entering the interceptor below.
    if (fallbackBtn) {
      fallbackBtn.addEventListener('click', function () {
        form.submit();
      });
    }

    function showError(text) {
      if (errorBox && errorMsg) {
        errorMsg.textContent = text;
        errorBox.hidden = false;
      }
    }

    function showBotCheck() {
      showError("One more step — Mailchimp needs to check you're human.");
      if (fallbackBtn) fallbackBtn.hidden = false;
    }

    function clearError() {
      if (errorBox) errorBox.hidden = true;
      if (fallbackBtn) fallbackBtn.hidden = true;
    }

    function showSuccess(text) {
      if (text && successMsg) successMsg.textContent = text;
      if (body) body.hidden = true;
      clearError();
      if (successBox) successBox.hidden = false;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearError();

      if (emailInput && !emailInput.checkValidity()) {
        emailInput.reportValidity();
        return;
      }

      var action = form.getAttribute('action').replace('/post?', '/post-json?');
      var params = new URLSearchParams(new FormData(form)).toString();
      // The callback name becomes a bare JS identifier in Mailchimp's response, so
      // every non-identifier char in the form id has to go — a hyphen makes the
      // response a subtraction expression that throws instead of calling us back.
      var cbName = 'wwrMcCallback_' + (++jsonpSeq) + '_' + String(form.id).replace(/[^A-Za-z0-9_$]/g, '_');
      var url = action + '&' + params + '&c=' + cbName;

      if (submit) {
        submit.classList.add('is-loading');
        submit.disabled = true;
      }

      var script = document.createElement('script');

      function cleanup() {
        try { delete window[cbName]; } catch (e) { window[cbName] = undefined; }
        if (script.parentNode) script.parentNode.removeChild(script);
        if (submit) {
          submit.classList.remove('is-loading');
          submit.disabled = false;
        }
      }

      window[cbName] = function (data) {
        cleanup();
        if (data && data.result === 'success') {
          showSuccess(null);
          return;
        }
        // Mailchimp errors often prefix "0 - " and may contain HTML — strip both.
        var raw = (data && data.msg) ? String(data.msg) : '';
        var msg = raw.replace(/^\d+\s*-\s*/, '').replace(/<[^>]*>/g, '').trim();
        // An audience with bot protection turned on answers a would-be successful
        // signup with an HTML captcha challenge rather than subscribing. Stripping
        // its tags leaves a bare word like "captcha", which tells a shopper
        // nothing — offer the hosted form instead. The second test catches an
        // unworded challenge: markup went in, almost no text came out.
        if (/captcha/i.test(raw) || (raw.indexOf('<') !== -1 && msg.length < 25)) {
          showBotCheck();
          return;
        }
        showError(msg || 'Something went wrong. Please try again.');
      };

      script.onerror = function () {
        cleanup();
        showError('Could not reach the signup service. Please try again later.');
      };

      script.src = url;
      document.body.appendChild(script);
    });
  }

  function initForms(root) {
    var forms = (root || document).querySelectorAll('.js-newsletter-form');
    for (var i = 0; i < forms.length; i++) initForm(forms[i]);
  }

  function initAll() {
    initAccordions(document);
    initForms(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-bind when re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    initAccordions(event.target);
    initForms(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
(function () {
  var jsonpSeq = 0;

  function init(form) {
    if (form.dataset.nlBound) return;
    form.dataset.nlBound = 'true';

    var body = form.querySelector('[data-nl-body]');
    var submit = form.querySelector('[data-nl-submit]');
    var successBox = form.querySelector('[data-nl-success]');
    var successMsg = form.querySelector('[data-nl-success-msg]');
    var errorBox = form.querySelector('[data-nl-error]');
    var errorMsg = form.querySelector('[data-nl-error-msg]');
    var emailInput = form.querySelector('input[name="EMAIL"]');
    var fallbackBtn = form.querySelector('[data-nl-fallback]');

    // Mailchimp's own hosted form is the only path that can satisfy the audience's
    // bot check, so hand the shopper over to it with the email carried across.
    // Two reasons this hangs off a real click rather than firing automatically
    // from the JSONP callback: form.submit() honours the form's target="_blank",
    // and a window opened from an async callback is outside the user-gesture
    // window, so the popup blocker eats it. form.submit() also does NOT fire a
    // submit event, which is what keeps it from re-entering the interceptor below.
    if (fallbackBtn) {
      fallbackBtn.addEventListener('click', function () {
        form.submit();
      });
    }

    function showError(text) {
      if (errorBox && errorMsg) {
        errorMsg.textContent = text;
        errorBox.hidden = false;
      }
    }

    function showBotCheck() {
      showError("One more step — Mailchimp needs to check you're human.");
      if (fallbackBtn) fallbackBtn.hidden = false;
    }

    function clearError() {
      if (errorBox) errorBox.hidden = true;
      if (fallbackBtn) fallbackBtn.hidden = true;
    }

    function showSuccess(text) {
      if (text && successMsg) successMsg.textContent = text;
      if (body) body.hidden = true;
      clearError();
      if (successBox) successBox.hidden = false;
    }

    form.addEventListener('submit', function (event) {
      // Progressive enhancement: only hijack when JSONP is viable.
      event.preventDefault();
      clearError();

      if (emailInput && !emailInput.checkValidity()) {
        emailInput.reportValidity();
        return;
      }

      // Build the request URL: /subscribe/post-json?<existing>&<fields>&c=<callback>
      var action = form.getAttribute('action').replace('/post?', '/post-json?');
      var params = new URLSearchParams(new FormData(form)).toString();
      // The callback name becomes a bare JS identifier in Mailchimp's response, so
      // every non-identifier char in the form id has to go — a hyphen makes the
      // response a subtraction expression that throws instead of calling us back.
      var cbName = 'wwrMcCallback_' + (++jsonpSeq) + '_' + String(form.id).replace(/[^A-Za-z0-9_$]/g, '_');
      var url = action + '&' + params + '&c=' + cbName;

      if (submit) {
        submit.classList.add('is-loading');
        submit.disabled = true;
      }

      var script = document.createElement('script');

      function cleanup() {
        try { delete window[cbName]; } catch (e) { window[cbName] = undefined; }
        if (script.parentNode) script.parentNode.removeChild(script);
        if (submit) {
          submit.classList.remove('is-loading');
          submit.disabled = false;
        }
      }

      window[cbName] = function (data) {
        cleanup();
        if (data && data.result === 'success') {
          // Keep the on-brand success copy from section settings (null = leave as-is).
          showSuccess(null);
          return;
        }
        // Mailchimp errors often prefix "0 - " and may contain HTML — strip both.
        var raw = (data && data.msg) ? String(data.msg) : '';
        var msg = raw.replace(/^\d+\s*-\s*/, '').replace(/<[^>]*>/g, '').trim();
        // An audience with bot protection turned on answers a would-be successful
        // signup with an HTML captcha challenge rather than subscribing. Stripping
        // its tags leaves a bare word like "captcha", which tells a shopper
        // nothing — offer the hosted form instead. The second test catches an
        // unworded challenge: markup went in, almost no text came out.
        if (/captcha/i.test(raw) || (raw.indexOf('<') !== -1 && msg.length < 25)) {
          showBotCheck();
          return;
        }
        showError(msg || 'Something went wrong. Please try again.');
      };

      script.onerror = function () {
        cleanup();
        showError('Could not reach the signup service. Please try again later.');
      };

      script.src = url;
      document.body.appendChild(script);
    });
  }

  function initAll() {
    var forms = document.querySelectorAll('.js-newsletter-form');
    for (var i = 0; i < forms.length; i++) init(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-bind when re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    var forms = event.target.querySelectorAll('.js-newsletter-form');
    for (var i = 0; i < forms.length; i++) init(forms[i]);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-modal"]) return;
  try {
    
(function () {
  var STORAGE_KEY = 'wwr_promo_modal_seen';
  var SUBSCRIBED_KEY = 'wwr_promo_modal_subscribed';
  var TAB_KEY = 'wwr_promo_tab_dismissed';
  var jsonpSeq = 0;

  /* ---- Mailchimp newsletter (JSONP) — shared with the Newsletter section ---- */
  function initForm(form, onSuccess) {
    if (form.dataset.nlBound) return;
    form.dataset.nlBound = 'true';

    var body = form.querySelector('[data-nl-body]');
    var submit = form.querySelector('[data-nl-submit]');
    var successBox = form.querySelector('[data-nl-success]');
    var successMsg = form.querySelector('[data-nl-success-msg]');
    var errorBox = form.querySelector('[data-nl-error]');
    var errorMsg = form.querySelector('[data-nl-error-msg]');
    var emailInput = form.querySelector('input[name="EMAIL"]');
    var fallbackBtn = form.querySelector('[data-nl-fallback]');

    // Mailchimp's own hosted form is the only path that can satisfy the audience's
    // bot check, so hand the shopper over to it with the email carried across.
    // Two reasons this hangs off a real click rather than firing automatically
    // from the JSONP callback: form.submit() honours the form's target="_blank",
    // and a window opened from an async callback is outside the user-gesture
    // window, so the popup blocker eats it. form.submit() also does NOT fire a
    // submit event, which is what keeps it from re-entering the interceptor below.
    // Note this path never reaches showSuccess, so onSuccess does not fire and the
    // subscribed flag stays unset — we cannot know whether they finished on
    // Mailchimp's page, and the reopen tab is better left than wrongly retired.
    if (fallbackBtn) {
      fallbackBtn.addEventListener('click', function () {
        form.submit();
      });
    }

    function showError(text) {
      if (errorBox && errorMsg) {
        errorMsg.textContent = text;
        errorBox.hidden = false;
      }
    }

    function showBotCheck() {
      showError("One more step — Mailchimp needs to check you're human.");
      if (fallbackBtn) fallbackBtn.hidden = false;
    }

    function clearError() {
      if (errorBox) errorBox.hidden = true;
      if (fallbackBtn) fallbackBtn.hidden = true;
    }

    function showSuccess(text) {
      if (text && successMsg) successMsg.textContent = text;
      if (body) body.hidden = true;
      clearError();
      if (successBox) successBox.hidden = false;
      if (typeof onSuccess === 'function') onSuccess();
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearError();

      if (emailInput && !emailInput.checkValidity()) {
        emailInput.reportValidity();
        return;
      }

      var action = form.getAttribute('action').replace('/post?', '/post-json?');
      var params = new URLSearchParams(new FormData(form)).toString();
      // The callback name becomes a bare JS identifier in Mailchimp's response, so
      // every non-identifier char in the form id has to go — a hyphen makes the
      // response a subtraction expression that throws instead of calling us back.
      var cbName = 'wwrMcCallback_' + (++jsonpSeq) + '_' + String(form.id).replace(/[^A-Za-z0-9_$]/g, '_');
      var url = action + '&' + params + '&c=' + cbName;

      if (submit) {
        submit.classList.add('is-loading');
        submit.disabled = true;
      }

      var script = document.createElement('script');

      function cleanup() {
        try { delete window[cbName]; } catch (e) { window[cbName] = undefined; }
        if (script.parentNode) script.parentNode.removeChild(script);
        if (submit) {
          submit.classList.remove('is-loading');
          submit.disabled = false;
        }
      }

      window[cbName] = function (data) {
        cleanup();
        if (data && data.result === 'success') {
          showSuccess(null);
          return;
        }
        // Mailchimp errors often prefix "0 - " and may contain HTML — strip both.
        var raw = (data && data.msg) ? String(data.msg) : '';
        var msg = raw.replace(/^\d+\s*-\s*/, '').replace(/<[^>]*>/g, '').trim();
        // An audience with bot protection turned on answers a would-be successful
        // signup with an HTML captcha challenge rather than subscribing. Stripping
        // its tags leaves a bare word like "captcha", which tells a shopper
        // nothing — offer the hosted form instead. The second test catches an
        // unworded challenge: markup went in, almost no text came out.
        if (/captcha/i.test(raw) || (raw.indexOf('<') !== -1 && msg.length < 25)) {
          showBotCheck();
          return;
        }
        showError(msg || 'Something went wrong. Please try again.');
      };

      script.onerror = function () {
        cleanup();
        showError('Could not reach the signup service. Please try again later.');
      };

      script.src = url;
      document.body.appendChild(script);
    });
  }

  /* ---- Modal open/close + gating ---- */
  function initModal(modal) {
    if (modal.dataset.pmBound) return;
    modal.dataset.pmBound = 'true';

    var designMode = modal.dataset.designMode === 'true';
    var enabled = modal.dataset.enabled === 'true';
    var scrollPx = parseInt(modal.dataset.scroll, 10);
    if (isNaN(scrollPx)) scrollPx = 0;
    var exitIntent = modal.dataset.exitIntent === 'true';
    var frequency = parseInt(modal.dataset.frequency, 10);
    if (isNaN(frequency)) frequency = 7;

    var dialog = modal.querySelector('.promo-modal__dialog');
    var closers = modal.querySelectorAll('[data-promo-close]');
    var form = modal.querySelector('.js-promo-newsletter-form');
    // The tab is a SIBLING of the modal (see the markup comment), so scope the
    // lookup to the section rather than to the modal.
    var sectionRoot = modal.closest('.shopify-section') || document;
    var tab = sectionRoot.querySelector('[data-promo-tab]');
    var tabOpenBtn = tab ? tab.querySelector('[data-promo-tab-open]') : null;
    var tabDismissBtn = tab ? tab.querySelector('[data-promo-tab-dismiss]') : null;
    var tabDismissedNow = false;
    var lastFocused = null;

    function stamp() {
      try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (e) {}
    }

    function subscribed() {
      try { return localStorage.getItem(SUBSCRIBED_KEY) === 'true'; } catch (e) { return false; }
    }

    // The tab's own dismissal rides the merchant's "days before showing again"
    // window, so there's no second knob to keep in sync. `frequency: 0` means
    // "show on every visit", which has to apply to the tab too — so in that
    // case the dismissal lasts for this page only and isn't persisted.
    function tabDismissed() {
      if (tabDismissedNow) return true;
      if (frequency <= 0) return false;
      var at = 0;
      try { at = parseInt(localStorage.getItem(TAB_KEY), 10) || 0; } catch (e) {}
      if (!at) return false;
      return (Date.now() - at) < frequency * 86400000;
    }

    function showTab() {
      if (!tab) return;
      // Never on top of the open modal — the URL trigger can open it before the
      // gate below runs, so this can't be left to call order.
      if (modal.classList.contains('is-open')) return;
      // Someone who already signed up doesn't need the offer dangled again —
      // but the merchant still needs to see the tab while styling it.
      if (!designMode && (subscribed() || tabDismissed())) return;
      tab.classList.add('is-visible');
    }

    function hideTab() {
      if (tab) tab.classList.remove('is-visible');
    }

    function dismissTab() {
      tabDismissedNow = true;
      // Hiding the focused element drops focus to <body>; blur first so that's
      // an explicit hand-off rather than a side effect of `visibility: hidden`.
      if (tabDismissBtn) tabDismissBtn.blur();
      hideTab();
      if (designMode || frequency <= 0) return;
      try { localStorage.setItem(TAB_KEY, String(Date.now())); } catch (e) {}
    }

    // Persist the dismissal for the whole audience once the user subscribes too,
    // and retire the reopen tab for good.
    if (form) {
      initForm(form, function () {
        if (designMode) return;
        stamp();
        try { localStorage.setItem(SUBSCRIBED_KEY, 'true'); } catch (e) {}
        hideTab();
      });
    }

    function getFocusable() {
      return dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      var items = getFocusable();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function open() {
      if (modal.classList.contains('is-open')) return;
      lastFocused = document.activeElement;
      hideTab();
      modal.classList.add('is-open');
      modal.removeAttribute('inert');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', onKeydown);
      // Defer focus a frame so it can't jank the opening transition.
      requestAnimationFrame(function () {
        var focusables = getFocusable();
        var target = modal.querySelector('input[name="EMAIL"]') || focusables[0];
        if (target) target.focus({ preventScroll: true });
      });
      if (!designMode) stamp();
    }

    function close() {
      if (!modal.classList.contains('is-open')) return;
      modal.classList.remove('is-open');
      modal.setAttribute('inert', '');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      // Reveal the tab BEFORE restoring focus: when the modal was opened from
      // the tab, `lastFocused` is the tab itself, and it can't take focus while
      // it's still `visibility: hidden`.
      showTab();
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus({ preventScroll: true });
      }
    }

    modal._promoOpen = open;
    modal._promoClose = close;

    for (var i = 0; i < closers.length; i++) {
      closers[i].addEventListener('click', close);
    }

    // The reopen tab bypasses the frequency gate entirely — it's an explicit
    // request for the offer, not an interruption.
    if (tabOpenBtn) {
      tabOpenBtn.addEventListener('click', function () { open(); });
    }
    if (tabDismissBtn) {
      tabDismissBtn.addEventListener('click', dismissTab);
    }

    // ---- URL trigger: any link ending in `#promo` opens the modal on demand ----
    // Like the reopen tab, this bypasses the frequency gate (and the subscribed
    // flag): following a link that says "get 15% off" IS a request for the
    // offer, not an interruption. Sanitised hard because it goes into a URL
    // comparison and comes from a free-text setting; an empty result falls back
    // to 'promo' rather than disabling, so a store whose stored settings predate
    // this setting still gets a working link.
    var urlKey = String(modal.dataset.urlHash || '').toLowerCase().replace(/[^a-z0-9_-]/g, '') || 'promo';

    function urlWantsModal() {
      if (window.location.hash.replace(/^#/, '').toLowerCase() === urlKey) return true;
      // Query-string form, for the places that strip fragments (some email and
      // SMS link wrappers). `?promo=0` / `?promo=false` opt out.
      var q = new URLSearchParams(window.location.search).get(urlKey);
      return q !== null && q !== '0' && q !== 'false';
    }

    // Strip the marker once it has fired: a refresh or a Back button shouldn't
    // re-open, and — the load-bearing half — clicking the SAME link again would
    // otherwise be a no-op, since re-setting an identical hash fires no
    // `hashchange`. replaceState keeps it out of the history stack.
    function cleanUrl() {
      if (!window.history || !window.history.replaceState) return;
      var params = new URLSearchParams(window.location.search);
      params.delete(urlKey);
      var qs = params.toString();
      try {
        window.history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : ''));
      } catch (e) {}
    }

    function openFromUrl() {
      if (!urlWantsModal()) return;
      cleanUrl();
      open();
    }

    window.addEventListener('hashchange', openFromUrl);
    openFromUrl();

    // Theme editor: don't auto-open on load (that would nag while editing other
    // sections). It opens only when the merchant selects this section — handled
    // by the shopify:section:select listener below. The tab is shown so it can
    // be styled without having to dismiss the modal first.
    if (designMode) {
      showTab();
      return;
    }

    if (!enabled) return;

    // Already open from the URL — don't arm the intent triggers behind it.
    // `open()` has stamped the gate, so the next page load behaves normally.
    if (modal.classList.contains('is-open')) return;

    // Frequency gate: only show if never seen or the window has elapsed.
    var seenAt = 0;
    try { seenAt = parseInt(localStorage.getItem(STORAGE_KEY), 10) || 0; } catch (e) {}
    if (seenAt && frequency > 0) {
      var elapsed = Date.now() - seenAt;
      // Suppressed on this visit — but still reachable from the tab.
      if (elapsed < frequency * 86400000) {
        showTab();
        return;
      }
    }

    // ---- Intent triggers: open on the first of scroll-depth / exit-intent. ----
    var triggered = false;
    var armTimer = null;

    function pageY() {
      return window.pageYOffset || document.documentElement.scrollTop || 0;
    }

    function onScroll() {
      if (pageY() >= scrollPx) trigger();
    }

    // Desktop exit-intent: the cursor leaves through the top of the viewport
    // (toward the tab bar / address bar) with nothing else under it.
    function onMouseOut(event) {
      if (event.relatedTarget || event.toElement) return;
      if (event.clientY <= 0) trigger();
    }

    // Leaving the site: the window loses focus (tab / app switch) or the tab
    // is backgrounded. Both map to "blurs away"; the trigger guard dedupes.
    function onBlur() { trigger(); }
    function onVisibility() {
      if (document.visibilityState === 'hidden') trigger();
    }

    function removeTriggers() {
      if (armTimer) { clearTimeout(armTimer); armTimer = null; }
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onMouseOut);
      window.removeEventListener('blur', onBlur);
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('pagehide', removeTriggers);
    }

    function trigger() {
      if (triggered) return;
      triggered = true;
      removeTriggers();
      open();
    }

    if (scrollPx > 0) {
      window.addEventListener('scroll', onScroll, { passive: true });
      // Cover a reload/deep-link that already lands past the threshold.
      onScroll();
    }

    if (exitIntent) {
      // Arm after a short grace so a background-tab load or an immediate focus
      // bounce doesn't fire exit-intent before the visitor has engaged.
      armTimer = setTimeout(function () {
        armTimer = null;
        document.addEventListener('mouseout', onMouseOut);
        window.addEventListener('blur', onBlur);
        document.addEventListener('visibilitychange', onVisibility);
      }, 1000);
    }

    // Drop all pending listeners if the page is torn down before either fires.
    window.addEventListener('pagehide', removeTriggers);
  }

  function initAll(root) {
    var modals = (root || document).querySelectorAll('[data-promo-modal]');
    for (var i = 0; i < modals.length; i++) initModal(modals[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Theme editor hooks.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:select', function (event) {
    var modal = event.target.querySelector('[data-promo-modal]');
    if (modal && modal._promoOpen) modal._promoOpen();
  });
  document.addEventListener('shopify:section:deselect', function (event) {
    var modal = event.target.querySelector('[data-promo-modal]');
    if (modal && modal._promoClose) modal._promoClose();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
